import React, { useContext } from 'react';
import { RestaurantMultipleSelect } from './components/RestaurantMultipleSelect/RestaurantMultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import {
	ChangePortionPositionContext,
	IChangePortionPositionContext,
	TChangePortionPositionSelectedRestaurant,
} from '../../../../../changePortionPositionState/changePortionPositionContext';
import style from './RestaurantField.module.scss';

export const RestaurantField: React.FC = () => {
	const { setAdditionalRestaurants, selectedAdditionalRestaurants } =
		useContext<IChangePortionPositionContext>(ChangePortionPositionContext);

	const handleRemove = (id: string) => {
		const selectedItems: TChangePortionPositionSelectedRestaurant[] = selectedAdditionalRestaurants.filter(
			(el) => el.id !== id,
		);
		setAdditionalRestaurants(selectedItems);
	};

	return (
		<div className={style.container} data-test="RestaurantField">
			<div className={style.field}>
				<RestaurantMultipleSelect />
			</div>
			<div className={style.groupsList}>
				{selectedAdditionalRestaurants.map((el) => (
					<SelectedItem key={el.id} label={el.name} onDelete={() => handleRemove(el.id)} />
				))}
			</div>
		</div>
	);
};
